import { CustomSVGProps } from './CustomSVGProps.types';
export function IconYoutube24(props: CustomSVGProps) {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden={!props.onClick}
            aria-label="youtube"
            xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.6857 7.5437C9.3758 7.39369 9.01053 7.41365 8.71882 7.59653C8.42711 7.77941 8.25 8.09949 8.25 8.44379V15.5562C8.25 15.9008 8.42738 16.2211 8.71945 16.4039C9.01151 16.5867 9.37711 16.6063 9.68702 16.4557L17.0199 12.8928C17.3645 12.7254 17.5832 12.3757 17.5829 11.9926C17.5826 11.6095 17.3634 11.2602 17.0186 11.0933L9.6857 7.5437ZM10.25 13.9586V10.0388L14.2912 11.995L10.25 13.9586Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.2596 3C2.89725 3 0.809191 4.66572 0.451367 7.06248C0.221044 8.60521 0 10.4744 0 12C0 13.5256 0.221044 15.3948 0.451367 16.9375C0.809191 19.3343 2.89724 21 5.2596 21H18.7404C21.1028 21 23.1908 19.3343 23.5486 16.9375C23.779 15.3948 24 13.5256 24 12C24 10.4744 23.779 8.60521 23.5486 7.06248C23.1908 4.66572 21.1028 3 18.7404 3H5.2596ZM2.42944 7.35779C2.6321 6.00039 3.82618 5 5.2596 5H18.7404C20.1738 5 21.3679 6.00039 21.5706 7.35779C21.7975 8.87791 22 10.6278 22 12C22 13.3722 21.7975 15.1221 21.5706 16.6422C21.3679 17.9996 20.1738 19 18.7404 19H5.2596C3.82618 19 2.6321 17.9996 2.42944 16.6422C2.2025 15.1221 2 13.3722 2 12C2 10.6278 2.2025 8.87791 2.42944 7.35779Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
